var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9D9B98",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1.767c-2.56 0-4.96.644-7.2 1.932a13.99 13.99 0 0 0-5.28 5.315A14.443 14.443 0 0 0 1.6 16.26c0 2.577.64 4.992 1.92 7.247a13.99 13.99 0 0 0 5.28 5.314c2.24 1.289 4.64 1.933 7.2 1.933 2.56 0 4.96-.644 7.2-1.933 2.24-1.288 4-3.06 5.28-5.314a14.443 14.443 0 0 0 1.92-7.247c0-2.577-.64-4.992-1.92-7.247a13.99 13.99 0 0 0-5.28-5.315c-2.24-1.288-4.64-1.932-7.2-1.932zm0-1.61c2.88 0 5.547.724 8 2.174a16.188 16.188 0 0 1 5.84 5.878C31.28 10.678 32 13.362 32 16.26s-.72 5.583-2.16 8.052A16.188 16.188 0 0 1 24 30.191c-2.453 1.45-5.12 2.174-8 2.174s-5.547-.724-8-2.174a16.188 16.188 0 0 1-5.84-5.878C.72 21.843 0 19.16 0 16.261s.72-5.583 2.16-8.052A16.188 16.188 0 0 1 8 2.33C10.453.88 13.12.157 16 .157z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.188 11.663l-3.26-3.282c-.058-.115-.143-.172-.258-.172h-.086c-.114 0-.2.057-.257.172L8.086 19.61a.77.77 0 0 0-.086.346v3.282c0 .115.043.216.129.302a.41.41 0 0 0 .3.13h3.26a.41.41 0 0 0 .301-.13.416.416 0 0 0 .129-.302.416.416 0 0 0-.129-.302.41.41 0 0 0-.3-.13H8.858v-2.677l7.466-7.514 2.66 2.677-5.835 5.787c-.115.115-.172.23-.172.345 0 .115.043.216.129.303a.41.41 0 0 0 .3.13c.114 0 .229-.058.343-.174l9.44-9.414a.77.77 0 0 0 .085-.345c0-.116-.028-.202-.086-.26zM19.584 14.6l-2.66-2.591 2.66-2.764 2.66 2.678-2.66 2.677z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.ab9ecb413ff6da60da7996588b814c04.svg";
export { ForwardRef as ReactComponent };